import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CSRFService } from './service/csrf.service';
@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private cSRFService: CSRFService) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const dmpServerUrl = "services/";
    const path = sessionStorage.overrideDmpUrl;
    if(path && path.length > 0 && (request.url.includes(dmpServerUrl))){
      const token = this.cSRFService.getCSRF();
      if(token && token.length > 0){
        request = request.clone({
          setHeaders: {
            'X-XSRF-TOKEN':  token
          }
        });
      }
    }
    return next.handle(request);
  }
}